module.exports = require("@native-ads/antd/lib/locale-provider/zh_CN");


//////////////////
// WEBPACK FOOTER
// external "@native-ads/antd/lib/locale-provider/zh_CN"
// module id = 120
// module chunks = 0